import * as React from 'react';
import * as ReactDOM from 'react-dom';

export const Portal: React.FC = ({ children }) => (
    ReactDOM.createPortal(
        children,
        document.body
    )
);
